enum MaterialPatrimonyAuthorTypeEnum {
    COMPANY = 'COMPANY',
    PERSON = 'PERSON',
}

export default MaterialPatrimonyAuthorTypeEnum;
